import { Breadcrumb, EventHandler } from "client/CommonComponents"

const AssetFleetProcessingBreadcrumb = (props: any) => {
    return (
        <div className="clearfix breadCrumbBlock mb-2">
            {
                <EventHandler onEvent={props?.onClickBack} data-attribute="AssetFleetProcessingBreadcrumb_Default_EventHandler">
                    <div className='backButton mb-sm-2 mb-3'>
                        <span className="fa fa-chevron-left"></span>
                        Back
                    </div>
                </EventHandler>
            }
            <div className="breadcrumbList">
                <Breadcrumb items={props?.breadcrumlist} maxDisplayedItems="5"  data-attribute="AssetFleetProcessingBreadcrumb_Default_Breadcrumb" />
            </div>
            <div className="float-right">
                <div className="pending">
                    <span>{props?.getOrderStatus("icon")}</span>
                    <span className="pending-approval-text">{props?.getOrderStatus("label")}</span>
                </div>
            </div>
        </div>
    )
}

export default AssetFleetProcessingBreadcrumb